import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "filter-container" }
const _hoisted_5 = {
  key: 0,
  class: "filter-site-container"
}
const _hoisted_6 = { class: "dataTable" }
const _hoisted_7 = { class: "container-header-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!
  const _component_ToasterSuccess = _resolveComponent("ToasterSuccess")!
  const _component_ModalChoixSite = _resolveComponent("ModalChoixSite")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.displayModalChoixSite)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('rapports.signer.header')) + " ", 1),
              _createVNode(_component_ReglePastille, { cle: "rapportsASigner.definition" })
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (!_ctx.isUniqueSite)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_ctx.$t('intervention.non-preventive.filter')) + " ", 1),
                    _createVNode(_component_ReglePastille, { cle: "rapportsASigner.filtreSiteUnique" }),
                    _createVNode(_component_ButtonBlue, {
                      "on-click": _ctx.selectionnerSite,
                      text: _ctx.$t('bouton.choix.site'),
                      class: "button-confirm btn",
                      disabled: _ctx.tableData.length === 0 && _ctx.isLoading
                    }, null, 8, ["on-click", "text", "disabled"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_Filter, {
                onSearch: _ctx.search,
                onSetInterventionId: this.setInterventionId,
                onSetPredictedDateFrom: this.setPredictedDateFrom,
                onSetPredictedDateTo: this.setPredictedDateTo,
                onClearFilter: this.clearFilter,
                filter: this.filter,
                searchSite: this.searchSite
              }, null, 8, ["onSearch", "onSetInterventionId", "onSetPredictedDateFrom", "onSetPredictedDateTo", "onClearFilter", "filter", "searchSite"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h2", null, [
                  _createTextVNode(_toDisplayString(this.count) + " " + _toDisplayString(_ctx.$t('rapports.signer.table.header')) + " ", 1),
                  _createVNode(_component_ReglePastille, { cle: "rapportsASigner.portee" }),
                  _createVNode(_component_ReglePastille, { cle: "rapportsASigner.selectionPourSignature" })
                ]),
                (!_ctx.isExportDisabled)
                  ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                      key: 0,
                      onClick: _ctx.exportXls,
                      imgUrl: _ctx.iconeXls,
                      title: _ctx.$t('list.export')
                    }, null, 8, ["onClick", "imgUrl", "title"]))
                  : _createCommentVNode("", true),
                (!_ctx.isSignerActivated)
                  ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                      key: 1,
                      onClick: _ctx.signerRapports,
                      imgUrl: _ctx.iconeSignature,
                      title: _ctx.$t('rapports.signer.bouton')
                    }, null, 8, ["onClick", "imgUrl", "title"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ReglePastille, { cle: "rapportsASigner.signerActif" })
              ]),
              (_ctx.tableData.length === 0 && _ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_LoaderComponent, {
                    key: 0,
                    class: "loader"
                  }))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    ref: "content",
                    onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
                    class: "datatable-container"
                  }, [
                    _createVNode(_component_DataTable, {
                      count: +_ctx.count,
                      isLoading: _ctx.isLoading,
                      tableData: this.tableData,
                      tableHeader: this.tableHeader,
                      "stop-propa-on-pdf": true,
                      "selected-items": _ctx.listRapportsIdSelected,
                      "document-list-to-download": _ctx.listRapportsIdSelected,
                      onSort: _ctx.doSort,
                      onSelect: _ctx.selectRapport,
                      onDownloadPdf: _ctx.downloadPdf
                    }, null, 8, ["count", "isLoading", "tableData", "tableHeader", "selected-items", "document-list-to-download", "onSort", "onSelect", "onDownloadPdf"])
                  ], 544))
            ]),
            (_ctx.signatureEnCours )
              ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isSuccessActive)
            ? (_openBlock(), _createBlock(_component_ToasterSuccess, {
                key: 0,
                message: _ctx.$t('rapports.signer.success')
              }, null, 8, ["message"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock(_component_ModalChoixSite, {
          key: 1,
          onCancel: _ctx.modalChoixSiteCancel,
          onValider: _ctx.validerSite,
          "selected-site": null,
          "selected-sites": _ctx.filter.siteList,
          "is-multi-site": true,
          "inclure-termines": true
        }, null, 8, ["onCancel", "onValider", "selected-sites"])),
    (_ctx.isXlsLoading)
      ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}